// ════════════ Clients.js ════════════
import React, { useEffect, useState } from 'react';
import { getClients, createClient, deleteClient, optimizeClient } from '../utils/api';
import { PageTitle, Card, Table, Btn, Input, Loading, Empty, statusBadge, Grid, StatCard } from '../components/UI';

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', businessName: '', phone: '', metaAccessToken: '', adAccountId: '', monthlyFee: '', maxDailyBudget: '' });
  const [adding, setAdding] = useState(false);
  const [acting, setActing] = useState(null);

  const load = () => getClients().then(r => setClients(r.data?.data?.clients || [])).catch(console.error).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    if (!form.name || !form.metaAccessToken || !form.adAccountId) return alert('name, token, accountId required');
    setAdding(true);
    await createClient({ ...form, monthlyFee: Number(form.monthlyFee), maxDailyBudget: Number(form.maxDailyBudget) }).catch(console.error);
    setForm({ name: '', businessName: '', phone: '', metaAccessToken: '', adAccountId: '', monthlyFee: '', maxDailyBudget: '' });
    await load();
    setAdding(false);
  };

  const handleOptimize = async (id, name) => {
    if (!window.confirm(`"${name}" এর AI optimization চালাবো? (Apply = true)`)) return;
    setActing(id);
    await optimizeClient(id, true).catch(console.error);
    setActing(null);
    alert('Optimization applied!');
  };

  return (
    <div>
      <PageTitle title="👥 Clients" sub="সব agency clients" />
      <Grid cols={3}>
        <StatCard label="Total Clients" value={clients.length} color="#a29bfe" />
        <StatCard label="Active" value={clients.filter(c => c.status === 'ACTIVE').length} color="#55efc4" />
        <StatCard label="Inactive" value={clients.filter(c => c.status === 'INACTIVE').length} color="#ff6584" />
      </Grid>
      <Card>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>নতুন Client যোগ করো</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
          <Input label="Client Name *" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <Input label="Business Name" value={form.businessName} onChange={e => setForm({ ...form, businessName: e.target.value })} />
          <Input label="WhatsApp Phone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="01XXXXXXXXX" />
          <Input label="Meta Access Token *" value={form.metaAccessToken} onChange={e => setForm({ ...form, metaAccessToken: e.target.value })} />
          <Input label="Ad Account ID *" value={form.adAccountId} onChange={e => setForm({ ...form, adAccountId: e.target.value })} placeholder="act_XXXXXXXXXX" />
          <Input label="Monthly Fee (BDT)" value={form.monthlyFee} onChange={e => setForm({ ...form, monthlyFee: e.target.value })} type="number" />
        </div>
        <Btn onClick={handleAdd} disabled={adding}>{adding ? 'Adding...' : '+ Add Client'}</Btn>
      </Card>
      <Card>
        {loading ? <Loading /> : clients.length === 0 ? <Empty msg="কোনো client নেই" /> : (
          <Table
            headers={['Name', 'Business', 'Ad Account', 'Status', 'Fee', 'Actions']}
            rows={clients.map((c, i) => (
              <tr key={i}>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <div style={{ fontWeight: 600 }}>{c.name}</div>
                  <div style={{ fontSize: 11, color: '#6b6b80' }}>{c.phone}</div>
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14 }}>{c.businessName}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 12, color: '#6b6b80' }}>{c.adAccountId}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>{statusBadge(c.status)}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14 }}>৳{c.monthlyFee}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <Btn color="#a29bfe" disabled={acting === c.id} onClick={() => handleOptimize(c.id, c.name)} style={{ fontSize: 12, padding: '6px 12px' }}>
                    🤖 Optimize
                  </Btn>
                </td>
              </tr>
            ))}
          />
        )}
      </Card>
    </div>
  );
}
